import React from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import { buttonStyles } from '../styles/styles'

const AddFormButton = ({ main, handleSave}) => {
    const buttonStyle = buttonStyles()
    const isDisabled = !main.selectedForm && !handleSave

    const AddFormClick = (event) => {
        if (handleSave) {
            handleSave();
        }
        else {
            let data = {
                type: "add_form",
                id: main.selectedForm.FormId
            }
            window.parent.postMessage(JSON.stringify(data), "*")
        }
        
    }

    return(
        <Button 
            className={buttonStyle.addForm}  
            disabled={isDisabled}
            onClick={AddFormClick}
            >
                insert form
        </Button>
    )
} 

const mapStateToProps = state => ({
    ...state
})

export default connect(mapStateToProps, {})(AddFormButton)